import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { withAccount } from '../../../components/AccountContext';
import SurveyRespondentCard from './SurveyRespondentCard';
import { intlShape } from '../../../components/prop-types';


const surveyGroupTypeMessages = defineMessages({
  self: { id: '360.self', defaultMessage: 'Self' },
});

class SurveySubRespondents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: [0],
    };
    this.tabChange = this.tabChange.bind(this);
  }

  tabChange(event) {
    const { index } = event;
    this.setState({ activeIndex: index });
  }

  render() {
    const {
      intl: { formatMessage },
      self,
    } = this.props;

    const groupName = formatMessage(surveyGroupTypeMessages.self);
    const { activeIndex } = this.state;
    return (
      <div className="accordion-legacy-container">
        <Accordion
          multiple
          activeIndex={activeIndex}
          onTabChange={this.tabChange}
        >
          <AccordionTab header={groupName}>
            <SurveyRespondentCard
              {...this.props}
              type="self"
              assessment={self}
            />
          </AccordionTab>
        </Accordion>
      </div>
    );
  }
}

SurveySubRespondents.propTypes = {
  self: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
};


export default withAccount(injectIntl(SurveySubRespondents));
